import React from 'react';
export var defaultLanguage = 'en-US';
var LocalizationContext = React.createContext({
  language: defaultLanguage
});
export default LocalizationContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/localization/Context.js
// module id = 330
// module chunks = 0